import { createStyles, Image, UnstyledButton } from '@mantine/core'

interface Props {
  selected: boolean
  onClick: () => void
  imgSrc: string
}

const useStyles = createStyles(theme => ({
  slide: {
    margin: '0 5px',
    position: 'relative'
  },
  thumb: {
    backgroundColor: 'transparent',
    border: '1px solid #CCCCCC',
    borderRadius: '5px',
    cursor: 'pointer',
    display: 'block',
    height: '100px',
    margin: 0,
    outline: 0,
    overflow: 'hidden',
    padding: 0,
    position: 'relative',
    touchAction: 'manipulation',
    width: '100px'
  },
  slideThumb: {
    bottom: 0,
    left: '-10000%',
    margin: 'auto',
    maxWidth: 'none',
    minWidth: '1000%',
    minHeight: '1000%',
    opacity: 0.2,
    position: 'absolute',
    right: '-10000%',
    top: 0,
    transform: 'scale(0.1)',
    transition: 'opacity 0.2s',
    '&[data-selected="true"]': { opacity: 1 }
  }
}))

export default function CarouselThumb({ selected, onClick, imgSrc }: Props) {
  const { classes } = useStyles()
  return (
    <div className={classes.slide}>
      <UnstyledButton
        onClick={onClick}
        className={classes.thumb}
        type="button"
      >
        <Image
          className={classes.slideThumb}
          data-selected={selected}
          src={imgSrc}
          alt=""
        />
      </UnstyledButton>
    </div>
  )
}
